import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar';
import ProjectNavbar from '../Components/Navbar/ProjectNavbar';
import useProjects from '../hooks/useProjects';
import '../Styles/ProjectDetail.css'

const ProjectDetail = () => {
    const [showImage, setShowImage] = useState(null)
    const { id } = useParams()
    // const [project, setProject] = useState([])
    // useEffect(() => {
    //     // fetch(`https://aqueous-forest-23721.herokuapp.com/projects/${id}`)
    //     fetch("projects.json")
    //         .then(res => res.json())
    //         .then(data => setProject(data))
    // }, [])
    // const { projects, setProjects } = useProjects()
    const projects = [
        {
            "_id": 5121,
            "projectName": "Bold Shovel - Menufacturer Website",
            "projectThumbnail": "https://i.ibb.co/RyfBHj7/Bold-Shovel-Thumb.png",
            "entireWebsite": "https://i.ibb.co/ry0YVT7/Bold-Shovel-Full.png",
            "technologies": [
                "React.js",
                "TailwindCSS",
                "Firebase",
                "Node.js",
                "ExpressJS",
                "MongoDB",
                "JWT"
            ],
            "features": [
                "The site is built using React.js, Tailwind, and some Vanilla CSS. The homepage and some other pages are public for every visitors. The homepage contains products, reviews, and more sections",
                "The authentication process is implemented for purchasing a product and accessing some more features. Clients can order and pay via the dedicated orders page in the Dashboard.",
                "All orders and user information are saved in MongoDB database. Although those user can update their orders and profile information from the Dashboard Panel. Data is secured on the server using JWT.",
                "Dedicated roles for admins. Admin can Manage Products, Add Products, Manage Users, and more."
            ],
            "paragraph": "I craft high-performing, beautiful websites that are conversion-focused, brand-accurate, & people-friendly.",
            "liveLink": "https://programminghero-assignment-12.web.app/",
            "clientRepo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-12-Client",
            "serverRepo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-12-Server",
            "screenshotOne": "https://i.ibb.co/CKDY4q9/Bold-Shovel-ss-1.png",
            "screenshotTwo": "https://i.ibb.co/BfH3pXp/Bold-Shovel-ss-2.png"
        },
        {
            "_id": 51213,
            "projectName": "Toy Merchandise - Warehouse website",
            "projectThumbnail": "https://i.ibb.co/Dz5G81L/Marvel-Bangladesh-Thumb.png",
            "entireWebsite": "https://i.ibb.co/r56m7Xx/Marvel-Bangladesh.png",
            "technologies": [
                "React.js",
                "Firebase",
                "Node.js",
                "ExpressJS",
                "MongoDB",
                "JWT"
            ],
            "features": [
                "Full website is developed using React.js and Vanilla CSS. The homepage contains Products, Products Summery, Navbar, Banners, and more sections.",
                "Users are required to authenticate themselves to access some features like Managing Inventory, Adding Products, updating Stocks and more.",
                "The server side of the application is built using Node.js, Express.js, cors, JWT. MongoDB is used for Database. The site is hosted on Firebase"
            ],
            "paragraph": "I craft high-performing, beautiful websites that are conversion-focused, brand-accurate, & people-friendly.",
            "liveLink": "https://programminghero-assignment-11.web.app/",
            "clientRepo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-11-Client",
            "serverRepo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-11-Server",
            "screenshotOne": "https://i.ibb.co/JvdV86N/Marvel-Bangladesh-ss-1.png",
            "screenshotTwo": "https://i.ibb.co/t3tx0Dg/Marvel-Bangladesh-ss-2.png"
        },
        {
            "_id": 51214,
            "projectName": "Max Fitness - Independend service Provider",
            "projectThumbnail": "https://i.ibb.co/MBvGsQF/Max-Fitness-Thumb.png",
            "entireWebsite": "https://i.ibb.co/2SD1p2b/Max-Fitness.png",
            "technologies": [
                "React.js",
                "CSS",
                "Firebase"
            ],
            "features": [
                "Max Fitness is built using React.js & Vanilla CSS. The site provides fitness services.",
                "Users need to Authenticate(Firebase) to purchasing a service.",
                "Fully Responsive and implemented Payment page."
            ],
            "paragraph": "I craft high-performing, beautiful websites that are conversion-focused, brand-accurate, & people-friendly.",
            "liveLink": "https://programminghero-assignment-10.web.app/",
            "Repo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-10",
            "screenshotOne": "https://i.ibb.co/G5Hwy4W/Max-Fitness-ss-1.png",
            "screenshotTwo": "https://i.ibb.co/CW4LVMF/Max-Fitness-ss-2.png"
        },
        {
            "_id": 51218,
            "projectName": "Resla Motors - Product Showcase",
            "projectThumbnail": "https://i.ibb.co/8c3C6mT/Resla-Motors-Thumb.png",
            "entireWebsite": "https://i.ibb.co/zNXb3Zn/Resla-Motors.png",
            "technologies": [
                "ReactJS"
            ],
            "features": [],
            "paragraph": "I craft high-performing, beautiful websites that are conversion-focused, brand-accurate, & people-friendly.",
            "liveLink": "https://assignment9byrokanuddin.netlify.app/home",
            "Repo": "https://github.com/rokanuddinroman/ProgrammingHero-Assignment-9",
            "screenshotOne": "https://i.ibb.co/xM5qqt2/Resla-Motors-ss-1.png",
            "screenshotTwo": "https://i.ibb.co/2W9v121/Resla-Motors-ss-2.png"
        }
    ]
    const project = projects.find(p => p.projectName.split(' ').join('-') == id)
    console.log(projects)
    console.log(id)
    console.log(project)

    return (
        <div style={{ position: "relative" }} className='conatiner_full__fixed'>
            <title>{project.projectName}</title>
            <ProjectNavbar />
            {
                showImage &&
                <div className="imageModal">
                    <button onClick={() => setShowImage(null)} className="modal__button">Close</button>
                    <img src={showImage} alt="" />
                </div>
            }
            <div className="project__container">
                <div className='project__detail'>
                    <div className="fixed">
                        <h1 style={{ fontSize: "30px", fontWeight: "800" }}>{project?.projectName}</h1>
                        <div className="badges">{
                            project?.technologies?.map(tech => <span className='badge-1'>{tech}</span>)
                        }</div>
                        <div>
                            <h2 className='project__description'>Description</h2>
                            <ul>
                                {
                                    project?.features?.map(feature => <li>{feature}</li>)
                                }
                            </ul>
                        </div>
                        <div className='project__links'>
                            {
                                project.Repo ?
                                    <button onClick={() => window.location.href = project?.Repo}>
                                        Github Repository
                                    </button>
                                    :
                                    <>
                                        <button onClick={() => window.location.href = project?.clientRepo}>
                                            Client Repository
                                        </button>
                                        <button onClick={() => window.location.href = project?.serverRepo}>
                                            Server Repository
                                        </button>
                                    </>
                            }
                            <span className="outline__link" onClick={() => window.location.href = project?.liveLink}>Live Site</span>
                        </div>
                        {/* <p>{project?.paragraph}</p> */}
                    </div>
                </div>
                <div style={{ position: "relative" }}>
                    <img src={project?.entireWebsite} alt="" />
                    <div className="project__ss">
                        <div className='project__ss__img'>
                            <img onClick={() => setShowImage(project?.screenshotOne)} src={project?.screenshotOne} alt="" />
                            <img onClick={() => setShowImage(project?.screenshotTwo)} src={project?.screenshotTwo} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetail;